import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
      light: '#42a5f5',
      dark: '#1565c0',
      contrastText: '#fff',
    },
    secondary: {
      main: '#dc004e',
      light: '#ff5983',
      dark: '#9a0036',
      contrastText: '#fff',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
    success: {
      main: '#2e7d32',
      light: '#4caf50',
      dark: '#1b5e20',
    },
    warning: {
      main: '#ed6c02',
      light: '#ff9800',
      dark: '#e65100',
    },
    error: {
      main: '#d32f2f',
      light: '#f44336',
      dark: '#c62828',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 500,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 500,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 500,
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 500,
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 500,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 500,
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '8px 16px',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          borderRadius: 12,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
        },
      },
    },
    // Fluid tables (ported from Dira360): containers never grow past their
    // parent, cells never force a column wider than its share, and headers wrap
    // instead of acting as `nowrap` minimums. Together these stop wide tables
    // from producing a page-level horizontal scrollbar and from thrashing layout
    // while the workspace re-renders.
    MuiTableContainer: {
      styleOverrides: {
        root: {
          width: '100%',
          maxWidth: '100%',
          minWidth: 0,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          // Digits line up in columns so money/quantity totals stop shifting.
          fontVariantNumeric: 'tabular-nums',
          // Let wrapping/ellipsis work inside flex and table layouts. Without
          // this, long references force columns wider than their container.
          minWidth: 0,
          overflowWrap: 'anywhere',
          wordBreak: 'break-word',
          verticalAlign: 'middle',
        },
        head: {
          fontWeight: 600,
          // Headers used to be `nowrap`, which made every column at least as
          // wide as its longest header word. Wrapping lets fluid tables fit.
          whiteSpace: 'normal',
          lineHeight: 1.3,
          verticalAlign: 'bottom',
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        toolbar: {
          flexWrap: 'wrap',
          justifyContent: 'flex-end',
          rowGap: 4,
        },
      },
    },
  },
});

export default theme;
